import Vue from 'vue'
import router from './router';
import store from './store'
import App from './App.vue'
import Request from '@/utils/request'
import Util from './utils/util'
import './utils/lazyload'
import {Base64} from 'js-base64'
import { checkRedirectToken } from './utils/auth'
import 'swiper/dist/css/swiper.min.css'
import 'swiper/dist/js/swiper.min'
import "tailwindcss/tailwind.css"
import './iview'
import base from './base'
Vue.use(base);
Vue.config.devtools = true;
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

import * as filters from './filters'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false

Vue.prototype.$http = Request

Vue.prototype.$store = store

router.beforeEach((to, from, next)=>{
    // 首访地址和来源地址
    Util.userSourceChannel()
    if(checkRedirectToken(to)){
        // 没登录直接重定向首页
        store.dispatch('login/login_open')
        return next({ name:'home.home.index'})
    }
    // 处理重定向
    if(to.name == 'home.news.link'){
        if(to.params.link){
            Util.redirect(Base64.decode(to.params.link))
            return
        }
        return next({ name:'home.home.index'})
    }
    if (to.path) {
        if (window._hmt) {
            window._hmt.push(['_trackPageview', '/#' + to.fullPath])
        }
    }
    Util.title(to.meta)
    next()
})
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

console.log("%c ".concat('西湖论剑'," %c ").concat('爱唯时空'," %c"),"background:#35495E; padding: 1px; border-radius: 3px 0 0 3px; color: #fff;","background:#19be6b; padding: 1px; border-radius: 0 3px 3px 0; color: #fff;",'background:transparent');

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
